import React, { useContext, useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { TextField, Button, Snackbar, Typography, RadioGroup, FormControlLabel, Radio, Checkbox } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from '@material-ui/pickers';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import MuiAlert from '@material-ui/lab/Alert';
import { HttpService } from '../../apiAuthorization/httpService';
import { ConvertToCurrentTimeZone, GetTimeZoneOffset } from '../header/timeFormatter';
import Grid from '@material-ui/core/Grid';
import { GlobalTheme } from '../../layouts/theme';
import { Context } from '../contexts/siteContext.js';
import { Theme } from '../contexts/themeContext.js';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: '7px 0px',
            width: '100%'
        }
    },
    button: {
        width: '15%',
        float: 'right'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    mb10: {
        marginBottom: "10px"
    },
    mb5: {
        marginBottom: "5px"
    }
}));

const PatientStatusAdd = forwardRef((props, ref) => {
    const classes = useStyles();
    const { theme } = useContext(Theme);
    const { defaultSite } = useContext(Context);
    const { patientSittingDto } = props;
    const currentTheme = theme ? (GlobalTheme[theme]) : (GlobalTheme[localStorage.getItem("theme")]);
    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [backDrop, setBackDrop] = useState(false);
    const [patientStatusDto, setPatientStatusDto] = useState({
        Id: 0,
        SiteId: defaultSite.id,
        PatientSittingId: patientSittingDto.Id,
        Isolation: "",
        IsolationType: "",
        PatientRestrictedToRoom: "",
        BedAlarm: "",
        PatientInGreenGown: "",
        AssistiveDevices: "",
        IsMealSetUp: false,
        Diet: "",
        Restrictions: "",
        Toileting: "",
        AmbulationMobility: "",
        MentalStatus: "",
        FallRisk: "",
        RNCompletingReport: "",
        RNDate: ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY hh:mm a", null, defaultSite),
        RNSignature: "",
        PatientObservationAttendant: ""
    });

    const [yesNoDDL] = useState([
        { Name: "Yes" },
        { Name: "No" }
    ]);

    const [onOffDDL] = useState([
        { Name: "On" },
        { Name: "Off" }
    ]);

    const [assistiveDevicesDDL] = useState([
        { Name: "Hearing Aid" },
        { Name: "Glasses" },
        { Name: "Walker/Cane" },
        { Name: "Dentures" },
        { Name: "N/A" }
    ]);

    const [toilstingDDL] = useState([
        { Name: "Bathroom with assist" },
        { Name: "Bedpan" },
        { Name: "Bedside commode" }
    ]);

    const [ambulationMobilityDDL] = useState([
        { Name: "With assistance" },
        { Name: "Bedrest" }
    ]);

    const [mentalStatusDDL] = useState([
        { Name: "Alert/Oriented" },
        { Name: "Quiet/Reserved" },
        { Name: "Angry/Upset" },
        { Name: "Confused/Disoriented" },
        { Name: "Combative" }
    ]);

    const [fallRiskDDL] = useState([
        { Name: "Low" },
        { Name: "Moderate" },
        { Name: "High" }
    ]);

    const closeErrorSnackbar = () => {
        setOpenError(false);
    };

    const onOptionChange = (key, event) => {
        var _PatientStatusDto = { ...patientStatusDto };
        if (key == "Isolation") {
            _PatientStatusDto.IsolationType = "";
        }

        _PatientStatusDto[key] = event.target.value;
        setPatientStatusDto(_PatientStatusDto);
    }

    const patientStatusDtoDateChanged = (key, date) => {
        date = moment(date).format("MM/DD/YYYY hh:mm a");
        var _PatientStatusDto = { ...patientStatusDto };
        _PatientStatusDto[key] = date;
        setPatientStatusDto(_PatientStatusDto);
    };

    const savePatientStatus = () => {
        var dto = patientStatusDto;
        /*
        if (!dto.PatientSittingId) {
            setErrorMessage("Please create a new observation first.");
            setOpenError(true);
            return false;
        }

        if (!dto.Isolation) {
            setErrorMessage("Please select the Isolation.");
            setOpenError(true);
            return false;
        }

        if (dto.Isolation == "Yes" && !dto.IsolationType) {
            setErrorMessage("Please enter Isolation Type.");
            setOpenError(true);
            return false;
        }

        if (!dto.PatientRestrictedToRoom) {
            setErrorMessage("Please select the Patient Restricted To Room.");
            setOpenError(true);
            return false;
        }

        if (!dto.BedAlarm) {
            setErrorMessage("Please select the Bed Alarm.");
            setOpenError(true);
            return false;
        }

        if (!dto.PatientInGreenGown) {
            setErrorMessage("Please select the Patient In Green Gown.");
            setOpenError(true);
            return false;
        }

        if (!dto.AssistiveDevices) {
            setErrorMessage("Please select the Assistive Devices.");
            setOpenError(true);
            return false;
        }

        if (dto.IsMealSetUp) {

            if (!dto.Diet) {
                setErrorMessage("Please enter the Diet.");
                setOpenError(true);
                return false;
            }

            if (!dto.Restrictions) {
                setErrorMessage("Please enter the Restrictions.");
                setOpenError(true);
                return false;
            }
        }

        if (!dto.Toileting) {
            setErrorMessage("Please select the Toileting.");
            setOpenError(true);
            return false;
        }

        if (!dto.AmbulationMobility) {
            setErrorMessage("Please select the Ambulation Mobility.");
            setOpenError(true);
            return false;
        }

        if (!dto.MentalStatus) {
            setErrorMessage("Please select the Mental Status.");
            setOpenError(true);
            return false;
        }

        if (!dto.FallRisk) {
            setErrorMessage("Please select the Fall Risk.");
            setOpenError(true);
            return false;
        }

        if (!dto.RNCompletingReport) {
            setErrorMessage("Please enter the RN Completing Report.");
            setOpenError(true);
            return false;
        }

        if (!dto.RNDate) {
            setErrorMessage("Please select the Date.");
            setOpenError(true);
            return false;
        }

        if (!dto.RNSignature) {
            setErrorMessage("Please enter the RNSignature.");
            setOpenError(true);
            return false;
        }

        if (!dto.PatientObservationAttendant) {
            setErrorMessage("Please enter the Patient Observation Attendant.");
            setOpenError(true);
            return false;
        }
        */
        HttpService.post('/PatientSitting/SavePatientStatus',
            dto
        )
            .then((result) => {
                setBackDrop(false);
                props.parentCallback();
            },
                (error) => {

                });
    };

    const getPatientStatus = () => {

        HttpService.post('/PatientSitting/GetPatientStatus',
            { PatientSittingId: patientStatusDto.PatientSittingId }
        )
            .then((result) => {
                setBackDrop(false);
                if (result.data) {
                    var dt = result.data;
                    setPatientStatusDto({
                        Id: dt.Id,
                        SiteId: defaultSite.id,
                        PatientSittingId: patientSittingDto.Id,
                        Isolation: dt.Isolation,
                        IsolationType: dt.IsolationType,
                        PatientRestrictedToRoom: dt.PatientRestrictedToRoom,
                        BedAlarm: dt.BedAlarm,
                        PatientInGreenGown: dt.PatientInGreenGown,
                        AssistiveDevices: dt.AssistiveDevices,
                        IsMealSetUp: dt.IsMealSetUp,
                        Diet: dt.Diet,
                        Restrictions: dt.Restrictions,
                        Toileting: dt.Toileting,
                        AmbulationMobility: dt.AmbulationMobility,
                        MentalStatus: dt.MentalStatus,
                        FallRisk: dt.FallRisk,
                        RNCompletingReport: dt.RNCompletingReport,
                        RNDate: moment(dt.RNDate),
                        RNSignature: dt.RNSignature,
                        PatientObservationAttendant: dt.PatientObservationAttendant
                    });
                }
            },
                (error) => {

                });
    }

    const cancel = () => {
        props.parentCallback();
    }


    useImperativeHandle(ref, () => {
        return {
            save: savePatientStatus
        };
    });

    useEffect(() => {
        getPatientStatus();
        // eslint-disable-next-line 
    }, []);

    return (
        <>
            <Backdrop className={classes.backdrop} id="addPatientStatusBackdrop" open={backDrop}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <div>
                <Snackbar open={openError} autoHideDuration={3000} onClose={closeErrorSnackbar} style={{ height: "100%" }}>
                    <Alert onClose={closeErrorSnackbar} severity="error">
                        {errorMessage}
                    </Alert>
                </Snackbar>

                <ValidatorForm autoComplete="off" onSubmit={savePatientStatus}>
                    <Grid
                        container
                        direction="row"
                        alignItems="center"
                        spacing={1} className={'mt-2'}>
                        <Grid item xs={12} sm={6}>
                            <Grid
                                container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                            >
                                <Grid item>
                                    <Typography variant="subtitle2" gutterBottom>
                                        Isolation <span style={{ color: 'red' }}></span>
                                    </Typography>
                                    <RadioGroup
                                        aria-label="position"
                                        name="position"
                                        value={patientStatusDto.Isolation}
                                        onChange={(e) => onOptionChange("Isolation", e)}
                                        row
                                    >
                                        <FormControlLabel
                                            key="Yes"
                                            value="Yes"
                                            control={<Radio style={{ color: currentTheme.secondary }} />}
                                            label="Yes"
                                            labelPlacement="end"
                                            style={{ color: currentTheme.text }}
                                        />
                                        <div style={{ margin: "0 10px 27px 0" }}>
                                            <TextField
                                                id="type"
                                                label="Type"
                                                disabled={patientStatusDto.Isolation != "Yes"}
                                                value={patientStatusDto.IsolationType || ""}
                                                onChange={(e) => { setPatientStatusDto({ ...patientStatusDto, IsolationType: e.target.value.trimStart() }); }}
                                            />
                                        </div>

                                        <FormControlLabel
                                            key="NO"
                                            value="NO"
                                            control={<Radio style={{ color: currentTheme.secondary }} />}
                                            label="NO"
                                            labelPlacement="end"
                                            style={{ color: currentTheme.text }}
                                        />
                                    </RadioGroup>
                                </Grid>
                            </Grid>
                        </Grid>

                        { /***Patient Restricted to Romm ***/}
                        <Grid item xs={12} sm={3}>
                            <Typography variant="subtitle2" gutterBottom>
                                Patient Restricted to Room <span style={{ color: 'red' }}></span>
                            </Typography>
                            <RadioGroup
                                aria-label="position"
                                name="position"
                                value={patientStatusDto.PatientRestrictedToRoom}
                                onChange={(e) => onOptionChange("PatientRestrictedToRoom", e)}
                                row
                            >
                                {
                                    yesNoDDL.map((option) =>
                                        <FormControlLabel
                                            key={option.Name}
                                            value={option.Name}
                                            control={<Radio style={{ color: currentTheme.secondary }} />}
                                            label={option.Name}
                                            labelPlacement="end"
                                            style={{ color: currentTheme.text }}
                                        />
                                    )
                                }
                            </RadioGroup>
                        </Grid>

                        { /*** Bed Alarm ***/}
                        <Grid item xs={12} sm={3}>
                            <Typography variant="subtitle2" gutterBottom>
                                Bed Alarm <span style={{ color: 'red' }}></span>
                            </Typography>
                            <RadioGroup
                                aria-label="position"
                                name="position"
                                value={patientStatusDto.BedAlarm}
                                onChange={(e) => onOptionChange("BedAlarm", e)}
                                row
                            >
                                {
                                    onOffDDL.map((option) =>
                                        <FormControlLabel
                                            key={option.Name}
                                            value={option.Name}
                                            control={<Radio style={{ color: currentTheme.secondary }} />}
                                            label={option.Name}
                                            labelPlacement="end"
                                            style={{ color: currentTheme.text }}
                                        />
                                    )
                                }
                            </RadioGroup>
                        </Grid>
                    </Grid>

                    { /*** Patient in green gown ***/}
                    <Grid
                        container
                        direction="row"
                        alignItems="center"
                        spacing={1}>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" gutterBottom>
                                Patient in green gown <span style={{ color: 'red' }}></span>
                            </Typography>
                            <RadioGroup
                                aria-label="position"
                                name="position"
                                value={patientStatusDto.PatientInGreenGown}
                                onChange={(e) => onOptionChange("PatientInGreenGown", e)}
                                row
                            >
                                {
                                    yesNoDDL.map((option) =>
                                        <FormControlLabel
                                            key={option.Name}
                                            value={option.Name}
                                            control={<Radio style={{ color: currentTheme.secondary }} />}
                                            label={option.Name}
                                            labelPlacement="end"
                                            style={{ color: currentTheme.text }}
                                        />
                                    )
                                }
                            </RadioGroup>
                        </Grid>

                        { /*** Assistive Devices ***/}
                        <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" gutterBottom>
                                Assistive Devices <span style={{ color: 'red' }}></span>
                            </Typography>
                            <RadioGroup
                                aria-label="position"
                                name="position"
                                value={patientStatusDto.AssistiveDevices}
                                onChange={(e) => onOptionChange("AssistiveDevices", e)}
                                row
                            >
                                {
                                    assistiveDevicesDDL.map((option) =>
                                        <FormControlLabel
                                            key={option.Name}
                                            value={option.Name}
                                            control={<Radio style={{ color: currentTheme.secondary }} />}
                                            label={option.Name}
                                            labelPlacement="end"
                                            style={{ color: currentTheme.text }}
                                        />
                                    )
                                }
                            </RadioGroup>

                        </Grid>
                    </Grid>

                    { /*** Patient needing dietary assistance ***/}
                    <Grid
                        container
                        direction="row"
                        justify="flex-start"
                        alignItems="center"
                        spacing={1} className={'mt-2'}>
                        <Grid item>
                            <Typography variant="subtitle2" gutterBottom>
                                Patient needing dietary assistance <span style={{ color: 'red' }}></span>
                            </Typography>
                            <FormControlLabel
                                label="Meal set-up"
                                control={
                                    <Checkbox
                                        checked={patientStatusDto.IsMealSetUp || false}
                                        onChange={(e) => { setPatientStatusDto({ ...patientStatusDto, IsMealSetUp: e.target.checked }); if (!e.target.checked) { patientStatusDto.Diet = ""; patientStatusDto.Restrictions = ""; } }}
                                        value="checkedA"
                                    />
                                }
                                style={{ color: currentTheme.text }}
                            />

                        </Grid>
                        <Grid item>
                            <TextField
                                id="diet"
                                label="Diet"
                                margin="normal"
                                disabled={!patientStatusDto.IsMealSetUp}
                                value={patientStatusDto.Diet || ""}
                                onChange={(e) => { setPatientStatusDto({ ...patientStatusDto, Diet: e.target.value.trimStart() }); }}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="restrictions"
                                label="Restrictions"
                                margin="normal"
                                disabled={!patientStatusDto.IsMealSetUp}
                                value={patientStatusDto.Restrictions || ""}
                                onChange={(e) => { setPatientStatusDto({ ...patientStatusDto, Restrictions: e.target.value.trimStart() }); }}
                            />
                        </Grid>
                    </Grid>

                    { /*** Toileting ***/}
                    <Grid
                        container
                        direction="row"
                        alignItems="center"
                        spacing={1} className={'mt-2'}>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" gutterBottom>
                                Toileting <span style={{ color: 'red' }}></span>
                            </Typography>
                            <RadioGroup
                                aria-label="position"
                                name="position"
                                value={patientStatusDto.Toileting}
                                onChange={(e) => onOptionChange("Toileting", e)}
                                row
                            >
                                {
                                    toilstingDDL.map((option) =>
                                        <FormControlLabel
                                            key={option.Name}
                                            value={option.Name}
                                            control={<Radio style={{ color: currentTheme.secondary }} />}
                                            label={option.Name}
                                            labelPlacement="end"
                                            style={{ color: currentTheme.text }}
                                        />
                                    )
                                }
                            </RadioGroup>
                        </Grid>
                        { /*** Ambulation/Mobility ***/}
                        <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" gutterBottom>
                                Ambulation/Mobility <span style={{ color: 'red' }}></span>
                            </Typography>
                            <RadioGroup
                                aria-label="position"
                                name="position"
                                value={patientStatusDto.AmbulationMobility}
                                onChange={(e) => onOptionChange("AmbulationMobility", e)}
                                row
                            >
                                {
                                    ambulationMobilityDDL.map((option) =>
                                        <FormControlLabel
                                            key={option.Name}
                                            value={option.Name}
                                            control={<Radio style={{ color: currentTheme.secondary }} />}
                                            label={option.Name}
                                            labelPlacement="end"
                                            style={{ color: currentTheme.text }}
                                        />
                                    )
                                }
                            </RadioGroup>

                        </Grid>
                    </Grid>


                    { /*** Mental Status ***/}
                    <Grid
                        container
                        direction="row"
                        alignItems="center"
                        spacing={1} className={'mt-2'}>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" gutterBottom>
                                Mental Status <span style={{ color: 'red' }}></span>
                            </Typography>
                            <RadioGroup
                                aria-label="position"
                                name="position"
                                value={patientStatusDto.MentalStatus}
                                onChange={(e) => onOptionChange("MentalStatus", e)}
                                row
                            >
                                {
                                    mentalStatusDDL.map((option) =>
                                        <FormControlLabel
                                            key={option.Name}
                                            value={option.Name}
                                            control={<Radio style={{ color: currentTheme.secondary }} />}
                                            label={option.Name}
                                            labelPlacement="end"
                                            style={{ color: currentTheme.text }}
                                        />
                                    )
                                }
                            </RadioGroup>
                        </Grid>
                    </Grid>

                    { /*** Fall Risk ***/}
                    <Grid
                        container
                        direction="row"
                        alignItems="center"
                        spacing={1} className={'mt-2'}>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" gutterBottom>
                                Fall Risk <span style={{ color: 'red' }}></span>
                            </Typography>
                            <RadioGroup
                                aria-label="position"
                                name="position"
                                value={patientStatusDto.FallRisk}
                                onChange={(e) => onOptionChange("FallRisk", e)}
                                row
                            >
                                {
                                    fallRiskDDL.map((option) =>
                                        <FormControlLabel
                                            key={option.Name}
                                            value={option.Name}
                                            control={<Radio style={{ color: currentTheme.secondary }} />}
                                            label={option.Name}
                                            labelPlacement="end"
                                            style={{ color: currentTheme.text }}
                                        />
                                    )
                                }
                            </RadioGroup>

                        </Grid>
                    </Grid>

                    { /*** RN Completing Report ***/}
                    <Grid
                        container
                        direction="row"
                        alignItems="center"
                        spacing={1} className={'mt-2'}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                id="rn-completing-report"
                                label=
                                {
                                    <Typography variant="subtitle2" gutterBottom>
                                        RN Completing Report (Print Name) <span style={{ color: 'red' }}></span>
                                    </Typography>
                                }
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                margin="normal"
                                style={{ marginBottom: "0px" }}
                                fullWidth
                                value={patientStatusDto.RNCompletingReport || ""}
                                onChange={(e) => { setPatientStatusDto({ ...patientStatusDto, RNCompletingReport: e.target.value.trimStart() }); }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" gutterBottom>
                                Date/Time <span style={{ color: 'red' }}></span>
                            </Typography>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDateTimePicker fullWidth hideTabs autoOk
                                    variant="inline"
                                    inputVariant="outlined"
                                    id="datetime"
                                    format="MM/dd/yyyy hh:mm a"
                                    size="small"
                                    //disablePast="true"
                                    value={patientStatusDto.RNDate}
                                    onChange={date => patientStatusDtoDateChanged('RNDate', date)}
                                    InputAdornmentProps={{ position: "start" }}
                                    PopoverProps={{
                                        anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                        transformOrigin: { horizontal: "left", vertical: "top" }
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                    </Grid>


                    { /*** RN Signature ***/}
                    <Grid
                        container
                        direction="row"
                        alignItems="center"
                        spacing={1} className={'mt-2'}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                id="rn-signature"
                                label=
                                {
                                    <Typography variant="subtitle2" gutterBottom>
                                        RN Signature <span style={{ color: 'red' }}></span>
                                    </Typography>
                                }
                                margin="normal"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                                value={patientStatusDto.RNSignature || ""}
                                onChange={(e) => { setPatientStatusDto({ ...patientStatusDto, RNSignature: e.target.value.trimStart() }); }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>

                            <TextField
                                id="patient-obsevation-attendant"
                                label=
                                {
                                    <Typography variant="subtitle2" gutterBottom>
                                        Patient Observation Attendant (Print Name) <span style={{ color: 'red' }}></span>
                                    </Typography>
                                }
                                margin="normal"
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={patientStatusDto.PatientObservationAttendant || ""}
                                onChange={(e) => { setPatientStatusDto({ ...patientStatusDto, PatientObservationAttendant: e.target.value.trimStart() }); }}
                            />
                        </Grid>
                    </Grid>


                    <Grid
                        container
                        direction="row"
                        alignItems="center"
                        spacing={1} className={'mt-2'}>

                        <Grid item xs={12} sm={12}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                className="mt-3"
                                style={{ background: currentTheme.secondary, width: "150px" }}
                                type="submit"
                                onSubmit={savePatientStatus}
                            >
                                Save
                            </Button>
                        </Grid>
                    </Grid>
                </ValidatorForm>
            </div>
        </>

    );
});
export default PatientStatusAdd;